import { CreateAccessLogPayload } from './types'
import client from '../../client'
import { ResponseSuccess } from '../../types'

export const createAccessLog = (payload: CreateAccessLogPayload) =>
  client.post<ResponseSuccess<null>>('v1/access-logs', payload)
